import { render, staticRenderFns } from "./navigation-menu-header.component.vue?vue&type=template&id=5cc64b94&scoped=true"
import script from "./navigation-menu-header.component.vue?vue&type=script&lang=ts"
export * from "./navigation-menu-header.component.vue?vue&type=script&lang=ts"
import style0 from "./navigation-menu-header.component.vue?vue&type=style&index=0&id=5cc64b94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc64b94",
  null
  
)

export default component.exports